export const RECALCULATION_METHODS = ["overwrite", "skip"] as const;

export const ROOM_FUNCTION_VARIANTS = ["template_function", "din_function"] as const;

export type RecalculationMethod = (typeof RECALCULATION_METHODS)[number];

export type RoomFunctionVariant = (typeof ROOM_FUNCTION_VARIANTS)[number];

export type TransientConfigurationFormState = TransientConfigurationPayload;

export type TransientConfigurationPayload = {
  delta_time_i: number;
  dynamic_hvac_start_point: boolean;
  percentile_to_consider: number;
  recalculation_method: RecalculationMethod;
  room_function_variant: string;
  scenarios: number[];
  t_air_exhaust: number;
  time_interval_in_min: number;
};

export const ROOM_FUNCTION_VARIANT_VALUES: Record<RoomFunctionVariant, string> = {
  din_function: "DIN function",
  template_function: "Template function",
};

export const DEFAULT_TRANSIENT_CONFIGURATION: TransientConfigurationFormState = {
  delta_time_i: 60,
  dynamic_hvac_start_point: false,
  percentile_to_consider: 95,
  recalculation_method: "skip",
  room_function_variant: ROOM_FUNCTION_VARIANT_VALUES.template_function,
  scenarios: [],
  t_air_exhaust: 22,
  time_interval_in_min: 15,
};

export const findRecalculationMethod = (value: unknown): RecalculationMethod | undefined =>
  RECALCULATION_METHODS.find((method) => method === value);

export const findRoomFunctionVariant = (value: unknown): RoomFunctionVariant | undefined =>
  ROOM_FUNCTION_VARIANTS.find((variant) => variant === value);

export const buildTransientConfigurationPayload = (
  configuration: TransientConfigurationFormState
): TransientConfigurationPayload => configuration;
